// Module
var code = "<a data-bind=\"click: Click, css: {'has-error': !_isValid()}\" class=\"tab-link\"> <span data-bind=\"text: Title\"></span> <i data-bind=\"css: {'hidden': _isValid}, tooltip: {}\" class=\"fa fa-warning control-tooltip\" title=\"This tab has required field\"></i> </a> ";
// Exports
export default code;